import React from 'react';
import { useSelector } from 'react-redux';
import { translationApi  } from 'actions/translation-api';

const TablePagination = (props) => {
    const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

    const visiblePagesFromCurrent = 2;
    const { currentPage, totalPages, totalItems } = props.pagination;
    const handlePageChange = page => {
        props.fetchList({page: page});
    };

    let pagingListItems = [];
    pagingListItems.push(<PreviousPageButton id="previousPageButton" key="previousPageButton" currentPage={currentPage} handlePageChange={handlePageChange} />);
    pagingListItems.push(<PageButton key={1} pageNumber={1} currentPage={currentPage} handlePageChange={handlePageChange} />);

    if (totalPages > 1) {
        if (currentPage - visiblePagesFromCurrent > 2) {
            pagingListItems.push(<Delimiter id="delimiter1" key="delimiter1" />);
        }

        const firstAdjacentPage = Math.max(currentPage - visiblePagesFromCurrent, 2);
        const lastAdjacentPage = Math.min(currentPage + visiblePagesFromCurrent, totalPages - 1)
        if (firstAdjacentPage <= lastAdjacentPage) {
            for (let i = firstAdjacentPage; i <= lastAdjacentPage; i++) {
                pagingListItems.push(<PageButton key={i} pageNumber={i} currentPage={currentPage} handlePageChange={handlePageChange} />);
            }
        }

        if (currentPage + visiblePagesFromCurrent + 1 < totalPages) {
            pagingListItems.push(<Delimiter id="delimiter2" key="delimiter2" />);
        }

        pagingListItems.push(<PageButton key={totalPages} pageNumber={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />);
    }

    pagingListItems.push(<NextPageButton id="nextPageButton" key="nextPageButton" currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />);
    
    return (
        <div className="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
            <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                    {pagingListItems}
                </ul>
            </nav>
            {translations &&
                <div id="totalItems" className="fw-bold small d-none d-lg-block">{translations.totalItemsCount}: <b>{totalItems}</b></div>
            }
        </div>
    );
}

const Delimiter = () => {
    return (
        <li className="page-item">
            <div className="page-link">
                <span aria-hidden="true">…</span>
            </div>
        </li>
    );
}

const PageButton = (props) => {
    const active = props.pageNumber === props.currentPage ? "active" : "";
    return (
        <li className={`page-item ${active}`}>
            {!active && <button className="page-link" onClick={() => props.handlePageChange(props.pageNumber)}>{props.pageNumber}</button>}
            {active && <div className="page-link">{props.pageNumber}</div>}
        </li>
    );
}

const PreviousPageButton = (props) => {
    const previousPageEnabled = props.currentPage > 1;
    return (
        <li className="page-item">
            {previousPageEnabled && <button className="page-link" aria-label="first link" onClick={() => props.handlePageChange(props.currentPage - 1)}><span className="fas fa-angle-left"></span></button>}
            {!previousPageEnabled && <div className="page-link"><span className="fas fa-angle-left"></span></div>}
        </li>
    );
}

const NextPageButton = (props) => {
    const nextPageEnabled = props.currentPage < props.totalPages;
    return (
        <li className="page-item">
            {nextPageEnabled && <button className="page-link" aria-label="first link" onClick={() => props.handlePageChange(props.currentPage + 1)}><span className="fas fa-angle-right"></span></button>}
            {!nextPageEnabled && <div className="page-link"><span className="fas fa-angle-right"></span></div>}
        </li>
    );
}

export default TablePagination;
